export const SUPPORTED_LANGUAGES = ['it', 'en', 'fr', 'es', 'de'] as const;

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'it';

export const LANGUAGE_STORAGE_KEY = 'easytools.language';

export const normalizeLanguage = (value?: string | null): SupportedLanguage => {
    const normalized = (value || '').trim().toLowerCase().split(/[-_]/)[0];
    return SUPPORTED_LANGUAGES.includes(normalized as SupportedLanguage)
        ? normalized as SupportedLanguage
        : DEFAULT_LANGUAGE;
};

export const getBrowserLanguage = (): SupportedLanguage => {
    if (typeof navigator === 'undefined') {
        return DEFAULT_LANGUAGE;
    }

    return normalizeLanguage(navigator.language);
};
